$(function(){
	$('.product-block .collapsibles-title').click(function(){
		//Expand or collapse this panel
		$(this).next().slideToggle(500);
		$('.product-block .collapsibles-title').toggleClass('open');
		var $this = $(this);
		if (!$this.hasClass('open')) {
			 $this.addClass('open');
		}
		//Hide the other panels
		$(".tab-collapsible-content").not($(this).next()).slideUp(500);
	});

	$(document).on('click', '.blog-nav-button', function(){
		$('.blog-links').toggleClass('show');
		$('body').toggleClass('disable-scroll');
	}); 
	
	$('.pdp-faq-question').click(function(){
		//Expand or collapse this panel
		$(this).next().slideToggle(500);
		$('.pdp-faq-question').parent().removeClass('active');
		$(this).parent().addClass('active');
		//Hide the other panels
		$(".pdp-faq-ans").not($(this).next()).slideUp(500);
	});
	(function($) {

		var Defaults = $.fn.select2.amd.require('select2/defaults');
	 
		$.extend(Defaults.defaults, {
		  dropdownPosition: 'auto'
		});
	 
		var AttachBody = $.fn.select2.amd.require('select2/dropdown/attachBody');
	 
		var _positionDropdown = AttachBody.prototype._positionDropdown;
	 
		AttachBody.prototype._positionDropdown = function() {
	 
		  var $window = $(window);
	 
		  var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
		  var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');
	 
		  var newDirection = null;
	 
		  var offset = this.$container.offset();
	 
		  offset.bottom = offset.top + this.$container.outerHeight(false);
	 
		  var container = {
				height: this.$container.outerHeight(false)
		  };
	 
		  container.top = offset.top;
		  container.bottom = offset.top + container.height;
	 
		  var dropdown = {
			 height: this.$dropdown.outerHeight(false)
		  };
	 
		  var viewport = {
			 top: $window.scrollTop(),
			 bottom: $window.scrollTop() + $window.height()
		  };
	 
		  var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
		  var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);
	 
		  var css = {
			 left: offset.left,
			 top: container.bottom
		  };
	 
		  // Determine what the parent element is to use for calciulating the offset
		  var $offsetParent = this.$dropdownParent;
	 
		  // For statically positoned elements, we need to get the element
		  // that is determining the offset
		  if ($offsetParent.css('position') === 'static') {
			 $offsetParent = $offsetParent.offsetParent();
		  }
	 
		  var parentOffset = $offsetParent.offset();
	 
		  css.top -= parentOffset.top
		  css.left -= parentOffset.left;
	 
		  var dropdownPositionOption = this.options.get('dropdownPosition');
	 
		  if (dropdownPositionOption === 'above' || dropdownPositionOption === 'below') {
			 newDirection = dropdownPositionOption;
		  } else {
	 
			 if (!isCurrentlyAbove && !isCurrentlyBelow) {
				newDirection = 'below';
			 }
	 
			 if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
				newDirection = 'above';
			 } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
				newDirection = 'below';
			 }
	 
		  }
	 
		  if (newDirection == 'above' ||
		  (isCurrentlyAbove && newDirection !== 'below')) {
				css.top = container.top - parentOffset.top - dropdown.height;
		  }
	 
		  if (newDirection != null) {
			 this.$dropdown
				.removeClass('select2-dropdown--below select2-dropdown--above')
				.addClass('select2-dropdown--' + newDirection);
			 this.$container
				.removeClass('select2-container--below select2-container--above')
				.addClass('select2-container--' + newDirection);
		  }
	 
		  this.$dropdownContainer.css(css);
	 
		};
	 
	 })(window.jQuery);
	
    jQuery('.product-single__meta .product__quantity .js-qty__num').select2({
        minimumResultsForSearch: Infinity,
		  dropdownPosition: 'below'
    });
	 
	jQuery('.sls-select-container').select2({
		minimumResultsForSearch: Infinity
  	});   
	 
	//jQuery('.desktop-only .collection-filter__sort-container .selector').select2({
		//minimumResultsForSearch: Infinity
    //});

    var zoomImages = $('.zoom-images');
    zoomImages.each(function () {
        $(this).imageZoom();
    });

	 $(".seal-subscription-page").before('<div class="page-width back-link-wrap"><a href="/account" aria-level="level1" class="back-link" style="display: block"><svg xmlns="http://www.w3.org/2000/svg" width="13.241" height="26.473" viewBox="4.239 -0.118 6.621 13.236"><g data-name="Group 926"><g data-name="Group 900"><path d="M4.24 13.118 10.86 6.5 4.245-.118" stroke-linejoin="round" stroke-linecap="round" stroke="#000" fill="transparent" data-name="Path 60"></path></g></g></svg><span>Account</span></a></div>');

	 $(document).on('click', '.cf-field-errors', function(){
		var inputField =  $(this).closest('div').find('input');
		$('.cf-field-errors').addClass('hide');
		$(inputField ).focus();
	}); 
	$(document).on('click', '.address-edit-toggle', function(){
		$('body').toggleClass('btn-popup-301-open');
		$('body').toggleClass('disable-scroll');
	}); 
	$(document).on('click', '.address-new-toggle', function(){
		$('body').toggleClass('btn-popup-301-open');
		$('body').toggleClass('disable-scroll');
	}); 
	
	$(document).on('click', '.btn-popup-301', function(){
		$('body').addClass('btn-popup-301-open');
	});
	$(document).on('click', '.kit-301-close', function(){
		$('body').removeClass('btn-popup-301-open');
		$('body').removeClass('disable-scroll');
		$('.js-address-form').removeClass('show');
	});
	$(document).on('click', 'body.template-product.btn-popup-301-open', function(){
		$('body').removeClass('btn-popup-301-open');
		$('body').removeClass('disable-scroll');
		$('.js-address-form').removeClass('show');
	});

	$(document).on('click', 'html.js-drawer-open--search #MainContent', function(){
		$('html').removeClass('js-drawer-open--search');
		$('html').removeClass('js-drawer-open');
		$('html').removeClass('lock-scroll');
		$('.site-header__search-container').removeClass('is-active');
	});
	
	$(document).on('click', '.wishlist-accordion', function(){
		$('.wk-product-info').removeClass('flexible');
		$(this).html("Hide Options");
		$(this).addClass('active');
		$('.wishlist-accordion').not(this).removeClass('active');
		$('.wishlist-accordion').not(this).html('see options');
		$('.wishlist-accordion').not(this).siblings('.wk-product-form').removeClass('show');
		$(this).siblings('.wk-product-form').toggleClass('show');
		
	});
	
  $(document).on('click', '.active.wishlist-accordion', function(){
	$(this).html("See Options");
	$('.wk-product-info').addClass('flexible');
	$(this).removeClass('active');
	$(this).siblings('.wk-product-form').removeClass('show');
  });
	if (window.location.href.indexOf("account-details") > -1) {
		$('.account-details-section').addClass('show');
		$('.account-details-section').removeClass('hide-section');
		$('.order-history-section').addClass('hide-section');
		$('.account-hub ').addClass('hide-section');
		$('.address-section-wrap ').addClass('hide-section');
		$('.on-screen-alert').addClass('hide-section');
		$('.order-history').removeClass('active');
  }
	if (window.location.href.indexOf("order-history") > -1) {
		$('.order-history-section').removeClass('hide-section');
		$('.account-details-section').addClass('hide-section');
		$('.account-hub ').addClass('hide-section');
		$('.address-section-wrap ').addClass('hide-section');
		$('.on-screen-alert').addClass('hide-section');
		$('.order-history').addClass('active');
		$('.account-details').removeClass('active');
  }
  if (window.location.href.indexOf("page=") > -1) {
	$('.order-history-section').removeClass('hide-section');
	$('.account-details-section').addClass('hide-section');
	$('.account-hub ').addClass('hide-section');
	$('.address-section-wrap ').addClass('hide-section');
	$('.on-screen-alert').addClass('hide-section');
	$('.order-history').addClass('active');
	$('.account-details').removeClass('active');
}
  if (window.location.href.indexOf("address-book") > -1) {
	$('.order-history-section').addClass('hide-section');
	$('.account-hub ').addClass('hide-section');
	$('.account-details-section').addClass('hide-section');
	$('.address-section-wrap').removeClass('hide-section');
	$('.address-section-wrap').addClass('show');
	$('.on-screen-alert').addClass('hide-section');
	}
	
	
	$(window).on("scroll",function(){
		if($(".cta__banner").length){ 
			var top = $(window).scrollTop(); 
			top>$(".collection-content").offset().top+200?$(".cta__banner").addClass("sticky"):$(".cta__banner").removeClass("sticky");
		}
	})
	
})

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

// slider
$slick_slider = $('.uvp-blocks-section:not(.uvp-blocks-section--loyalty) .uvp-items');
settings_slider = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false
}
slick_on_mobile($slick_slider, settings_slider);

$mobile_slick_slider = $('.mob-promo-slider');
slick_on_mobile($mobile_slick_slider, {
    slidesToShow: 1,
    slidesToScroll: 1,
	adaptiveHeight: true,
    dots: false,
    arrows: true
}, 768);

$partner_slick_slider = $('.partner-with-us .grid.grid--uniform');
slick_on_mobile($partner_slick_slider, {
    slidesToShow: 1,
    slidesToScroll: 1,
	adaptiveHeight: true,
    dots: false,
    arrows: false
}, 768);

// slick on mobile
function slick_on_mobile(slider, settings, width = 767) {
    $(window).on('load resize', function () {
        if ($(window).width() > width) {
            if (slider.hasClass('slick-initialized')) {
                slider.slick('unslick');
            }
            return
        }
        if (!slider.hasClass('slick-initialized')) {
            return slider.slick(settings);
        }
    });
};

slickOnResize();

$(window).resize(function(){
	var $window_width = $(window).width();
	if ($window_width < 1200) {
		$(".more-to-love-slider").slick("resize");
	}
});
$('.featured-slider-main').slick({
	infinite: true,
	slidesToShow: 3,
	slidesToScroll: 3,
	responsive: [
		{
			breakpoint: 1199,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				arrows: false
			}
		},
		{
			breakpoint: 640,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false
			}
		}
	]
});

$('#aboutTimeline').slick({
	infinite: false,
	slidesToShow: 6,
	slidesToScroll: 2,
	arrows: false,
	dots: true,
	responsive: [
		{
		breakpoint: 1763,
		settings: {
			slidesToShow: 4,
			slidesToScroll: 1,
		}
		},
		{
		breakpoint: 1200,
		settings: {
			slidesToShow: 3,
			slidesToScroll: 1,
		}
		},
		{
		breakpoint: 1024,
		settings: {
			slidesToShow: 2,
			slidesToScroll: 1,
		}
		},
		{
		breakpoint: 600,
		settings: {
			slidesToShow: 1,
			slidesToScroll: 1,
		}
		},
	]
});

function slickOnResize(){
$('.more-to-love-slider').slick({
	infinite: true,
	slidesToShow: 4,
	slidesToScroll: 3,
   mobileFirst: true,
	arrows: false,
	responsive: [
		{
			breakpoint: 992,
			settings: "unslick"
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 350,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
		
	]
});
}
slickOnResizeBlog();

$(window).resize(function(){
	var $window_width = $(window).width();
	if ($window_width < 992) {
		$(".blog-post-slider").slick("resize");
	}
});
function slickOnResizeBlog(){
$('.blog-post-slider').slick({
	infinite: true,
	slidesToShow: 2,
	slidesToScroll: 2,
   mobileFirst: true,
	arrows: false,
	responsive: [
		{
			breakpoint: 992,
			settings: "unslick"
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 350,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
		
	]
});
}
slickOnResizeBlogMain();

$(window).resize(function(){
	var $window_width = $(window).width();
	if ($window_width < 767) {
		$(".blog-post-slider-main").slick("resize");
	}
});
function slickOnResizeBlogMain(){
$('.blog-post-slider-main').slick({
	infinite: true,
	slidesToShow: 4,
	slidesToScroll: 3,
   mobileFirst: true,
	arrows: false,
	responsive: [
		{
			breakpoint: 768,
			settings: "unslick"
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 350,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
		
	]
});
}

$('select[name=locations]').change(function() {
	var filter = $(this).val();
	filterList(filter);
});

//News filter function
function filterList(value) {

	var checkedValue = new Array(); 

		 var inputElements = document.getElementsByClassName('check');
		 for(var i=0; inputElements[i]; ++i){
	  if(inputElements[i].checked){
			 checkedValue.push(inputElements[i].value);
	  }
		 }

	  var list = $(".locations .location");
	$(list).fadeOut("fast");

	if (value == "all") {
			$(".locations").find(".location").each(function () {
			  $(this).delay(200).slideDown("fast");
		 });
	} else {
		 if(checkedValue.indexOf(value) < 0) {
			  checkedValue.push(value);
		 } 

		 filter = new Array;

		 checkedValue.forEach(function(entry) {
		 filter.push("[data-filter=" + entry + "]");

					});

		 miVar1 = filter.join(",");
		 console.log(miVar1);

			  $(".locations").find(miVar1).each(function () {
			  $(this).delay(200).slideDown("fast");
		 });
	}
}

$(document).ready(function () {
	$(".locations .location").slice(0, 5).addClass('shows');
	if ($(".locations .location:hidden").length != 0) {
		$("#load-more").addClass('shows');
	}
	$("#load-more").on("click", function (e) {
		e.preventDefault();
		$(".locations .location:hidden").slice(0, 5).addClass('shows');;
		if ($(".locations .location:hidden").length == 0) {
			$("#load-more").text("No More to view").fadOut("slow");
		}
	});
});
$( ".label.collapsibles-title" ).first().addClass( "open" );
$( ".tab-collapsible-content" ).first().css( 'display','block' );

$(document).ready(function(){
	$( ".faq-blocks-section .c-faqs__item:first-of-type .c-faqs__item__title" ).addClass( "c-faqs__item__title--open" );
	$(".product-block-lash-for .c-faqs__item:first-of-type .c-faqs__item__title").addClass( "c-faqs__item__title--open" );
});
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

$('.testimonial-grid-slider .grid.grid--uniform').slick({
	infinite: true,
	slidesToShow: 3,
	slidesToScroll: 1,
	arrows: true,
	adaptiveHeight: true,
	responsive: [
		{
			breakpoint: 640,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
	]
});
$('.expand-expertise-grid .grid.grid--uniform').slick({
	infinite: false,
	slidesToShow: 5,
	slidesToScroll: 1,
	arrows: true,
	adaptiveHeight: true,
	responsive: [
		{
			breakpoint: 1199,
			settings: {
				slidesToShow: 4,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 640,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}
	]
});

$('.slider-slider').slick({
	infinite: true,
	slidesToShow: 4,
	slidesToScroll: 1,
	arrows: true,
	// prevArrow: $('.arr-prev'),
	// nextArrow: $('.arr-next'),
	responsive: [
		{
			breakpoint: 1199,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				arrows: true,
				dots:true
			}
		},
		{
			breakpoint: 640,
			settings: {
				dots:true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true
			}
		}
	]
});


$('.home-collection-slider').slick({
	slidesToShow: 4,
	slidesToScroll: 3,
	arrows: true,
	responsive: [
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}		
	]
});
slick_on_mobile(
	$('.partner-with-us > .grid'),
	{
	slidesToShow: 2,
	slidesToScroll: 2,
	arrows: false,
	responsive: [
		{
			breakpoint: 650,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
		
	]},
	768
);
slick_on_mobile(
	$('.home-press .grid.grid--uniform'),
	{
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false}
);
slick_on_mobile(
	$('.home-press-mobshow .grid.grid--uniform'),
	{
	slidesToShow: 2,
	slidesToScroll: 2,
	centerMode: true,
	centerPadding: '25px',
	arrows: false,
	responsive: [
		{
			breakpoint: 650,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
		
	]},
	768
);
/*$(document).on('click', '.js-drawer-open-cart', function(){
	// event.detail will be Shopify Cart object
	// console.log($('.shoppinggives-tag'));
	var myVar = setInterval(() => {
		var $elem = $('.shoppinggives-tag').parent().clone();
		if($('.footer.sticky-footer  .shoppinggives-tag').length){
			clearInterval(myVar);
		}else{
			$elem.insertBefore( $('.footer-checkbox') );
		}
	}, 1000);
});
window.addEventListener('SCE:add', (event) => {
	// event.detail will be Shopify Cart object
	if($('.footer.sticky-footer  .shoppinggives-tag').length == 0){
		var myVar = setInterval(() => {
			var $elem = $('.shoppinggives-tag').parent().clone();
			$elem.insertBefore( $('.footer-checkbox') );
			if($('.footer.sticky-footer  .shoppinggives-tag').length){
				clearInterval(myVar);
			}else{
				$elem.insertBefore( $('.footer-checkbox') );
			}
		}, 1000);
	}
});*/
mobileTopMenu();
$(window).resize(function(){
	mobileTopMenu();
})
function mobileTopMenu(){
	var $window_width = $(window).width();
	if ($window_width <= 768) {
		
	$('.navigation-below-menu .site-nav--has-dropdown ').on('touchstart', function() {
		detectTap = true; // Detects all touch events
	});
	$('.navigation-below-menu .site-nav--has-dropdown ').on('touchmove', function() {
		detectTap = false; // Excludes the scroll events from touch events
	});
	$('.navigation-below-menu .site-nav--has-dropdown ').on('click touchend', function(event) {
		if (event.type == "click") detectTap = true; // Detects click events
		   if (detectTap){
			  // Here you can write the function or codes you want to execute on tap
			//   event.preventDefault();
			  // Do some stuff

			  $('.navigation-below-menu .site-nav--has-dropdown.is-active').not(this).each(function(){
				var $otherLi = $(this);
				var $otherPanel = $otherLi.data('navPanel') || $otherLi.children('.site-nav__dropdown, .megamenu');
				$otherLi.removeClass('is-active').removeData('navPanel');
				$otherPanel.removeClass('site-nav__dropdown--detached').removeAttr('style').appendTo($otherLi);
			  });

			  var $li = $(this);

			  if(!$li.hasClass('is-active')){
				var $panel = $li.children('.site-nav__dropdown, .megamenu');
				var linkRect = $li.children('.site-nav__link')[0].getBoundingClientRect();
				$li.addClass('is-active').data('navPanel', $panel);
				$panel.addClass('site-nav__dropdown--detached')
					.css('top', (linkRect.bottom + window.pageYOffset) + 'px')
					.appendTo(document.body);
			  }
			  else{
				var $panel = $li.data('navPanel') || $li.children('.site-nav__dropdown, .megamenu');
				$li.removeClass('is-active').removeData('navPanel');
				$panel.removeClass('site-nav__dropdown--detached').removeAttr('style').appendTo($li);
			  }
		   }
	 });
	}
}
let hasMoreContent = 0;
$('#col--desc').children().each((elem) => {
	hasMoreContent++;
});
if(hasMoreContent > 0){
	$('#col--desc').children(":first").addClass('first-content').append('<span class="read-more-btn" id="readMoreBtn"> Read More</span>');
	$('#col--desc').children(":not(.first-content)").addClass('hid-content');
	$('#col--desc').children(":last").append('<span class="read-more-btn hid-content" id="readLessBtn"> See Less</span>')
	$(document).on('click', '#readMoreBtn', function(){
		$('.hid-content').addClass('show');
		$(this).hide();
	});
	$(document).on('click', '#readLessBtn', function(){
		$('.hid-content').removeClass('show');
		$(this).hide();
		$('#readMoreBtn').show();
	});
}
$('.btn-pdp-redirect').on('click', function(e){
	e.preventDefault();
	let hrefLink = $(this).data('href');
	let productUrl = $(this).data('product');
	localStorage.setItem("redirectpage", productUrl);
	window.location = hrefLink;
});
if($('body').hasClass('template-pro-thank-you')){
	if(localStorage.getItem("redirectpage")){
		var url = localStorage.getItem("redirectpage");
		localStorage.removeItem("redirectpage");
		$('.dnt_acc .btn').attr('href',url);
	}
}
var chkvar = setInterval(() => {
	if($('#slidecart-checkout-form redo-shopify-toggle').length){
		clearInterval(chkvar);
		$('#slidecart-checkout-form redo-shopify-toggle').addClass('disabled-checkout');
		$('.disabled-checkout [data-target="coverage-button"]').on('click', function(e){
			e.preventDefault();
		});
	}
}, 100);

var myVar = setInterval(() => {
	if($('#slidecart-agree').length){
		clearInterval(myVar);
		$('#slidecart-agree').on('change', function(e){
			$('#slidecart-checkout-form redo-shopify-toggle').toggleClass('disabled-checkout');
		});
	}
}, 1000);
document.addEventListener("DOMContentLoaded", function() {
  if (typeof window.productData === 'undefined') return;

  const product = window.productData;

  // group radio inputs by option name
  const optionGroups = {};
  document.querySelectorAll('input[type="radio"][data-product-option]').forEach(radio => {
    const optionName = radio.getAttribute('data-product-option');
    if (!optionGroups[optionName]) optionGroups[optionName] = [];
    optionGroups[optionName].push(radio);
  });

  function updateOptions() {
    // get currently selected values
    const selected = {};
    Object.keys(optionGroups).forEach(name => {
      const checked = optionGroups[name].find(r => r.checked);
      if (checked) selected[name] = checked.value;
    });

    // loop through each group
    Object.keys(optionGroups).forEach((name, idx) => {
      optionGroups[name].forEach(radio => {
        // create a test selection
        const testSelection = [];
        product.options.forEach((opt, i) => {
          if (opt === name) {
            testSelection[i] = radio.value;
          } else {
            testSelection[i] = selected[opt] || null;
          }
        });

        // check if variant exists with this combination
        const match = product.variants.find(v =>
          v.options.every((val, i) => !testSelection[i] || testSelection[i] === val)
        );

        if (!match || !match.available) {
          radio.disabled = true;
          radio.parentElement.classList.add("unavailable"); // add CSS class for styling
        } else {
          radio.disabled = false;
          radio.parentElement.classList.remove("unavailable");
        }
      });
    });
  }

  // add event listeners
  Object.values(optionGroups).flat().forEach(radio => {
    radio.addEventListener("change", updateOptions);
  });

  updateOptions(); // run on page load
});
$(document).on('click', '.clear-cart-link', function(event) {
  event.preventDefault(); // Prevent default link behavior
  fetch('/cart/clear.js', { // Using the Fetch API for a more modern approach
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
	console.log(response);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    console.log('Cart cleared:', data);
    location.reload(); // Reload the page to reflect the cleared cart
  })
  .catch(error => {
    console.error('Error clearing cart:', error);
  });
});
initLogoSlider();
$(window).resize(function(){
	initLogoSlider();
});
function initLogoSlider() {
	if($('.logo-slider').hasClass('slick-initialized')) {
		$('.logo-slider').slick('unslick');
	}
	if(window.innerWidth < 768) {		
		$('.logo-slider').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			rows: 2,
			slidesPerRow: 1,
			autoplay: true,
			arrows: true,
			adaptiveHeight: true,
		});
	} else {		 
		$('.logo-slider').slick({
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			autoplay: true,
			arrows: true,
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: 1199,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
					}
				}
			]
		});
	}
}